import { useState } from 'react';
import { Button, CardMedia, Stack, TextField } from '@mui/material';
import { updateClinic } from '@app/api/clinic';
import { IClinic } from '@app/interfaces/clinic.interface';

interface ImageFieldProps {
  clinic: IClinic;
  field: string;
}

export function ImageField({ field, clinic }: ImageFieldProps) {
  const [imageUrl, setImageUrl] = useState(clinic[field]);
  const [loading, setLoading] = useState(false);

  const disabled = imageUrl === clinic[field];

  const onSave = async () => {
    const updatedClinic = Object.assign({}, clinic, { [field]: imageUrl });
    setLoading(true);
    updateClinic(updatedClinic)
      .then()
      .catch((e) => {
        console.log(e);
      })
      .finally(() => setLoading(false));
  };

  return (
    <Stack direction='row' spacing={2}>
      <CardMedia
        component='img'
        sx={{ width: 160 }}
        image={imageUrl ? imageUrl : '/assets/images/no-image.jpg'}
      />

      <Stack spacing={2}>
        <TextField
          margin='dense'
          id={field}
          label='URL'
          fullWidth
          value={imageUrl}
          onChange={(event) => setImageUrl(event.target.value)}
        />

        <Button disabled={disabled || loading} onClick={onSave}>
          Сохранить
        </Button>
      </Stack>
    </Stack>
  );
}
